import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-cloudnative-journey/ibm-cloudnative-journey/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import Globals from 'gatsby-theme-carbon/src/templates/Globals';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const InlineNotification = makeShortcode("InlineNotification");
const Tabs = makeShortcode("Tabs");
const Tab = makeShortcode("Tab");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Use Tekton to automate your continuous integration process`}</p>
    </PageDescription>
    <h2>{`Overview`}</h2>
    <p>{`Continuous integration is a software development technique where software is built regularly by a team in an automated fashion.`}</p>
    <p>{`Tekton is a new emerging CI tool that has been built to support Kubernetes and OpenShift from the ground up.`}</p>
    <h2>{`What is Tekton`}</h2>
    <p><a parentName="p" {...{
        "href": "https://tekton.dev/"
      }}>{`Tekton`}</a>{` is a powerful yet flexible Kubernetes-native open-source framework for creating continuous integration and delivery (CI/CD) systems. It lets you build, test, and deploy across multiple cloud providers or on-premises systems by abstracting away the underlying implementation details.`}</p>
    <h3>{`Tekton 101`}</h3>
    <iframe width="80%" height="315" src="https://www.youtube.com/embed/TWxKD9dLpmk" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <p>{`Tekton provides open-source components to help you standardize your CI/CD tooling and processes across vendors, languages, and deployment environments. Industry specifications around pipelines, releases, workflows, and other CI/CD components available with Tekton will work well with existing CI/CD tools such as Jenkins, Jenkins X, Skaffold, and Knative, among others.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`For more information read up about it `}<a parentName="p" {...{
            "href": "https://developer.ibm.com/tutorials/knative-build-app-development-with-tekton/"
          }}>{`Tekton Tutorial`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`For more information read up about it `}<a parentName="p" {...{
            "href": "https://developer.ibm.com/tutorials/knative-build-app-development-with-tekton/"
          }}>{`App Build Tutorial with Tekton`}</a></p>
      </li>
    </ul>
    <p>{`The IBM Cloud is standardizing on using Tekton in both IBM Cloud DevOps
service and IBM Cloud Pak for Applications. OpenShift 4.2 will also natively
support it.`}</p>
    <p>{`This guide will focus on using Tekton when the Development tools have been
installed in Redhat OpenShift, IBM Kubernetes Managed services and `}<strong parentName="p">{`Red Hat
Code Ready Containers`}</strong>{` to give you choice for you Continuous Integration
cloud native development toolset.`}</p>
    <InlineNotification mdxType="InlineNotification">
      <p><strong parentName="p">{`Note:`}</strong>{` This guide will help you set up the `}<a parentName="p" {...{
          "href": "/ibm-cloudnative-journey/resources/codepatterns-overview"
        }}><Globals name="templates" mdxType="Globals" /></a>{` with  `}<strong parentName="p">{`Tekton`}</strong>{` and requires that you have installed Tekton with `}<strong parentName="p">{`Red Hat Code Ready Containers 4.2`}</strong>{` or have installed open source Tekton into the The IBM Kubernetes Cluster.`}</p>
    </InlineNotification>
    <h3>{`Common App Tasks`}</h3>
    <p>{`The following gives a description of each `}<inlineCode parentName="p">{`Task`}</inlineCode>{` that is commonly used in a
`}<inlineCode parentName="p">{`Pipeline`}</inlineCode>{`. The `}<em parentName="p">{`Optional`}</em>{` stages can be deleted or ignored if the tool support it is not installed. These stages represent a typical production pipeline flow for a Cloud Native application.`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Setup`}</strong>{` clones the code into the pipeline`}</li>
      <li parentName="ul"><strong parentName="li">{`Build`}</strong>{` runs the build commands for the code`}</li>
      <li parentName="ul"><strong parentName="li">{`Test`}</strong>{`	validates the unit tests for the code`}</li>
      <li parentName="ul"><strong parentName="li">{`Publish pacts`}</strong>{`	(`}<em parentName="li">{`optional`}</em>{`) publishes any pact contracts that have been defined`}</li>
      <li parentName="ul"><strong parentName="li">{`Verify pact`}</strong>{` (`}<em parentName="li">{`optional`}</em>{`) verifies the pact contracts`}</li>
      <li parentName="ul"><strong parentName="li">{`Sonar scan`}</strong>{` (`}<em parentName="li">{`optional`}</em>{`) runs a sonar code scan of the source code and publishes the results to SonarQube`}</li>
      <li parentName="ul"><strong parentName="li">{`Build image`}</strong>{` Builds the code into a Docker images and stores it in the IBM Cloud Image registry`}</li>
      <li parentName="ul"><strong parentName="li">{`Deploy to DEV env`}</strong>{`	Deploys the Docker image tagged version to `}<inlineCode parentName="li">{`dev`}</inlineCode>{` namespace using Helm Chart`}</li>
      <li parentName="ul"><strong parentName="li">{`Health Check`}</strong>{` Validates the Health Endpoint of the deployed application`}</li>
      <li parentName="ul"><strong parentName="li">{`Package Helm Chart`}</strong>{` (`}<em parentName="li">{`optional`}</em>{`) Stores the tagged version of the Helm chart into Artifactory`}</li>
      <li parentName="ul"><strong parentName="li">{`Trigger CD Pipeline`}</strong>{` (`}<em parentName="li">{`optional`}</em>{`) This is a GitOps stage that will
update the build number in designated git repo and trigger ArgoCD for
deployment to `}<strong parentName="li">{`test`}</strong>{` namespace`}</li>
    </ul>
    <h3>{`Install Tekton`}</h3>
    <p>{`Tekton can be installed in both RedHat Openshift and IBM Kubernetes manage
service and RedHat Code Ready Containers. To install the necessary
components follow the steps below.`}</p>
    <ul>
      <li parentName="ul">{`Install IBM Garage for Cloud Developer Tools on your
managed OpenShift,CRC or IKS development cluster on the IBM Cloud. This will
help configure the tools and `}<inlineCode parentName="li">{`secrets`}</inlineCode>{` and `}<inlineCode parentName="li">{`configMap`}</inlineCode>{` to make working with
IBM Cloud so much easier.
`}</li>
    </ul>
    <Tabs mdxType="Tabs">
      <Tab label="OpenShift 4.x" mdxType="Tab">
        <h3>{`Install on OpenShift 4.x`}</h3>
        <ul>
          <li parentName="ul">
            <p parentName="li">{`If you have installed the IBM Garage for Cloud Developer Tools into your
cluster this will automatically install the operator for you.`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Install Tekton on OpenShift 4 including CodeReady Containers (CRC)`}</p>
            <ul parentName="li">
              <li parentName="ul">{`Install via operator hub Administrator perspective view, click
`}<strong parentName="li">{`Operator Hub`}</strong>{` search for `}<inlineCode parentName="li">{`OpenShift Pipelines`}</inlineCode>{` and install operator`}</li>
            </ul>
          </li>
        </ul>
      </Tab>
      <Tab label="Kubernetes" mdxType="Tab">
        <h3>{`Install Tekton on IBM Kubernetes Managed Service`}</h3>
        <ul>
          <li parentName="ul">{`Install Tekton via Knative add-on (can be found in the `}<strong parentName="li">{`Add On`}</strong>{` tab in
the Kubernetes managed service dashboard)
, it includes
Tekton support by default and the Webhook extension. `}</li>
          <li parentName="ul">{`Install `}<a parentName="li" {...{
              "href": "https://github.com/tektoncd/dashboard#install-dashboard"
            }}>{`Tekton Dashboard`}</a>{` follow the instructions in the `}<inlineCode parentName="li">{`README.md`}</inlineCode></li>
          <li parentName="ul">{`Add Ingress endpoint for the `}<strong parentName="li">{`Tekton Dashboard`}</strong>{` add a host name that uses
the IKS cluster subdomain     `}<pre parentName="li"><code parentName="pre" {...{
                "className": "language-yaml"
              }}>{`  apiVersion: extensions/v1beta1
  kind: Ingress
  metadata:
    name: tekton-dashboard
    namespace: tekton-pipelines
  spec:
    rules:
    - host: tekton-dashboard.showcase-dev-iks-cluster.us-south.containers.appdomain.cloud
      http:
        paths:
        - backend:
            serviceName: tekton-dashboard
            servicePort: 9097
`}</code></pre></li>
          <li parentName="ul">{`Install `}<a parentName="li" {...{
              "href": "https://github.com/tektoncd/experimental/tree/master/webhooks-extension#install-webhook-extension"
            }}>{`Tekton Webhook Extension`}</a>{` `}</li>
        </ul>
      </Tab>
    </Tabs> 
    <h3>{`Setup Tekton`}</h3>
    <ul>
      <li parentName="ul">{`Install Tekton pipelines and tasks into the `}<inlineCode parentName="li">{`dev`}</inlineCode>{` namespace following the
instructions in the repository `}<a parentName="li" {...{
          "href": "https://github.com/ibm-garage-cloud/ibm-garage-tekton-tasks/blob/master/README.md"
        }}>{`ibm-garage-tekton-tasks`}</a></li>
      <li parentName="ul">{`Install the `}<inlineCode parentName="li">{`Tasks`}</inlineCode><pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`kubectl create -f ibm-garage-tekton-tasks/tasks/ -n dev
`}</code></pre></li>
      <li parentName="ul">{`Install the `}<inlineCode parentName="li">{`Pipelines`}</inlineCode><pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`kubectl create -f ibm-garage-tekton-tasks/pipelines/ -n dev  
`}</code></pre></li>
    </ul>
    <h3>{`Configure namespace for development`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Install the Tekton CLI `}<inlineCode parentName="p">{`tkn`}</inlineCode>{` `}<a parentName="p" {...{
            "href": "https://github.com/tektoncd/cli"
          }}>{`https://github.com/tektoncd/cli`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Create a new namespace (ie `}<inlineCode parentName="p">{`dev-{initials}`}</inlineCode>{`) and copy all config and secrets`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`igc namespace -n {new-namespace}
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Set your `}<inlineCode parentName="p">{`new-namespace`}</inlineCode>{` the current namespace context`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`oc project {new-namespace}
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li">{`The template `}<inlineCode parentName="p">{`Pipelines`}</inlineCode>{` provided support for `}<inlineCode parentName="p">{`Java`}</inlineCode>{` or `}<inlineCode parentName="p">{`Node.js`}</inlineCode>{` based apps. You can configure your own custom `}<inlineCode parentName="p">{`Tasks`}</inlineCode>{` for other runtimes. There are a number of default `}<inlineCode parentName="p">{`Tasks`}</inlineCode>{` to get you started they are detailed above. To create an application use one of the provided `}<a parentName="p" {...{
            "href": "/ibm-cloudnative-journey/resources/codepatterns-overview"
          }}><Globals name="templates" mdxType="Globals" /></a>{` these templates work seamlessly with the `}<inlineCode parentName="p">{`Tasks`}</inlineCode>{` and `}<inlineCode parentName="p">{`Pipelines`}</inlineCode>{` provided.`}</p>
      </li>
    </ul>
    <h3>{`Register the App with Tekton`}</h3>
    <p>{`With Tetkon enabled and your default `}<inlineCode parentName="p">{`Tasks`}</inlineCode>{` and `}<inlineCode parentName="p">{`Pipelines`}</inlineCode>{` installed into
the `}<inlineCode parentName="p">{`dev`}</inlineCode>{` namespace. You can now configure your applications to be built, packaged, tested and deployed to your OpenShift or Kubernetes development cluster.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Connect to the pipeline. (See the `}<a parentName="p" {...{
            "href": "/ibm-cloudnative-journey/getting-started/cli"
          }}>{`IGC CLI`}</a>{` for details about how the `}<inlineCode parentName="p">{`pipeline`}</inlineCode>{` command works.)`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`igc pipeline -n dev-{initials} --tekton
`}</code></pre>
      </li>
    </ul>
    <h3>{`Verify the pipeline`}</h3>
    <p>{`To validate your pipeline have been correctly configured, and has triggered a
`}<inlineCode parentName="p">{`PipelineRun`}</inlineCode>{`
use the following `}<strong parentName="p">{`Tekton`}</strong>{` dashboards or `}<inlineCode parentName="p">{`tkn`}</inlineCode>{` CLI to validate it ran
correctly without errors.`}</p>
    <Tabs mdxType="Tabs">
      <Tab label="OpenShift 4.x" mdxType="Tab">
        <ul>
          <li parentName="ul">
            <p parentName="li">{`Review you `}<strong parentName="p">{`Pipeline`}</strong>{` in the OpenShift 4.x Console
`}<span parentName="p" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "28.47222222222222%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAAAsSAAALEgHS3X78AAAA6klEQVQY04VQS07DMBD1/e/CDZB6ALYsWRCJAmrrxonrz/j3GI9JirrhyaM4nvH7WFlrMdB4NV73+g+1VtRSZD+/HHB6foISqvZbg3ZHexB4FCMihBCQc97vqEnf8LkQvlbC0UQsPiHxYB8SB1wbwd//IvuGzRAxsV0WqECZmw25VPnG4EAx3J+BESML8XDheIWFghvP1Ji0n3enIsJ9pdcESmV38XElXNjxzWe4OKIYY+Rix2nWeJ00Jl1gwxDoRJt7Icx5HHAoHOcMbRMsR4+piMt1tXDOC+HZeLx9e7xfkhD2fo8u7rl+AHIB1iF/pBiDAAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "Pipelinerun",
                  "title": "Pipelinerun",
                  "src": "/ibm-cloudnative-journey/static/b9f14d105bd04e3cddc427d9b8f046f1/3cbba/pipeline.png",
                  "srcSet": ["/ibm-cloudnative-journey/static/b9f14d105bd04e3cddc427d9b8f046f1/7fc1e/pipeline.png 288w", "/ibm-cloudnative-journey/static/b9f14d105bd04e3cddc427d9b8f046f1/a5df1/pipeline.png 576w", "/ibm-cloudnative-journey/static/b9f14d105bd04e3cddc427d9b8f046f1/3cbba/pipeline.png 1152w", "/ibm-cloudnative-journey/static/b9f14d105bd04e3cddc427d9b8f046f1/0b124/pipeline.png 1728w", "/ibm-cloudnative-journey/static/b9f14d105bd04e3cddc427d9b8f046f1/4ea69/pipeline.png 2304w", "/ibm-cloudnative-journey/static/b9f14d105bd04e3cddc427d9b8f046f1/dd77a/pipeline.png 2484w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span></p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Review your `}<strong parentName="p">{`Tasks`}</strong>{`
`}<span parentName="p" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "34.375%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAAAsSAAALEgHS3X78AAAA0ElEQVQoz5WSaw7CIBCEuf9hvIG38KeJT9RSLfIq0BZGoLGpURPdZPKRLAyzBMJkD2UctFJQSV3XIcaIXyvGUKjXK9TLBciRd7gLBSlFkiymwzAU038UwoDQ9yDS+JTQwzkHP0tXNiK+8s0kjOsn01GSU3HOi4wxZWTv/Xf6kX1KM108E+H3BqeKouE37OkOt2bkpTrjdKGgZwpWM2wPG9TXeupprSfDeREhBJRWMK1Bm+S8Q2tbWGthnS3r/By5n/nsfU3IGCvj5pH+rU+/4QECeiNOg/7XvwAAAABJRU5ErkJggg==')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "Tasks",
                  "title": "Tasks",
                  "src": "/ibm-cloudnative-journey/static/43ac10b40fa67d0ebd944161e29cdbca/3cbba/tasks.png",
                  "srcSet": ["/ibm-cloudnative-journey/static/43ac10b40fa67d0ebd944161e29cdbca/7fc1e/tasks.png 288w", "/ibm-cloudnative-journey/static/43ac10b40fa67d0ebd944161e29cdbca/a5df1/tasks.png 576w", "/ibm-cloudnative-journey/static/43ac10b40fa67d0ebd944161e29cdbca/3cbba/tasks.png 1152w", "/ibm-cloudnative-journey/static/43ac10b40fa67d0ebd944161e29cdbca/0b124/tasks.png 1728w", "/ibm-cloudnative-journey/static/43ac10b40fa67d0ebd944161e29cdbca/4ea69/tasks.png 2304w", "/ibm-cloudnative-journey/static/43ac10b40fa67d0ebd944161e29cdbca/f0987/tasks.png 2490w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span></p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Review your `}<strong parentName="p">{`Steps`}</strong>{`
`}<span parentName="p" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "1152px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "44.79166666666667%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAABaElEQVQoz51Ry0rDQBTNJ1QXtlgIWB9ZWD9AFBVsodiF4N6dP+CPCO4Ff8DWqh+hG5eWPqh9WjHJJGnTSSZNm2NmpKWCIO2Fy5y5c+6ZM3cky7JgGIZIQggGAwoeQRBM1wmerU9xgF88yXEoiEngUAe2bYMYBL1eD/2+DZ3o4BfaHBs6TNMUHCPkcx7nmJYpeJzD+6R2p4WX12eUKyXUG3UUq2/4/OqGTQaqjQoa7brAtWb1B4dCrY8mKu9lqJoquKVaEZquQtc1SNnsCRRFQTK5DVmWUbgviCdwJx7z4LgOaPiKKaYUjDG4zBV15jKxp3QA13UhHaUPEJdXEV2JIhKJIJe7E4Lj8RiLhJTOppDYSmBjcxPRWAz5h0dx4I9G00HPk1ImvQ9lLY6d9QTiy0vI396E9nz4Hvvzl/91eHlxjtPUIc5Sx8js7eLp+gpo1eA7dDFBTdXQ7XRCRx5GwyFmJzeP0CS+AXwNiaSX2/kmAAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "Steps",
                  "title": "Steps",
                  "src": "/ibm-cloudnative-journey/static/c5055673e16d6d6c72b473519809cd64/3cbba/steps.png",
                  "srcSet": ["/ibm-cloudnative-journey/static/c5055673e16d6d6c72b473519809cd64/7fc1e/steps.png 288w", "/ibm-cloudnative-journey/static/c5055673e16d6d6c72b473519809cd64/a5df1/steps.png 576w", "/ibm-cloudnative-journey/static/c5055673e16d6d6c72b473519809cd64/3cbba/steps.png 1152w", "/ibm-cloudnative-journey/static/c5055673e16d6d6c72b473519809cd64/0b124/steps.png 1728w", "/ibm-cloudnative-journey/static/c5055673e16d6d6c72b473519809cd64/f7471/steps.png 1776w"],
                  "sizes": "(max-width: 1152px) 100vw, 1152px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span></p>
          </li>
        </ul>
      </Tab>
      <Tab label="Opensource Tekton Dashboard" mdxType="Tab">
        <p>{`If you are running Tekton with IBM Cloud Pak for Applications or Knative with
Kubernetes managed service your dashboard view will look similar to below.`}</p>
        <ul>
          <li parentName="ul">{`Review your `}<strong parentName="li">{`Pipeline`}</strong>
            <span parentName="li" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "1152px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "47.56944444444444%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAABk0lEQVQoz41Su0oDQRTdn7C0FMHGyh+wsrSxE4tU1ipiI1glaGMjgq3YCYIKCloKgvgCIQSNooJgs5tkd7Pz3JnjnclDYyI4u5d57J1zzzl3g+fyB9JMojOse6xtra3tC5eBH9m9eyCo1QUSZsA1wLmAEjmUNH49aDjM/vguGDDOIaTyAIzi/ukCDy+XqDdihFENYa1O6wSNOEWtHiNjAlxKcKEoX4LRXsgcTBAJmoNqtYooihCFIeKkicpbGW+fr9AKkNyCkR1pmqLZzNCgIlwQAcUgCVQI4UNpgyYJ8oCcGGqtvRxjgJvHO5xcHeH0+hjnt/uovN96WTo3oNdfVtq2507k9D2nYhpBkiQEZLx+d2H7cAlzpREU1scwvTpE+8V2sXxgk76bRYoUMcyyrNsxx3DrYAmzxVEUNsYxszaMneOVNqDpXuxv1A/AOI7JVGoII1+Uwe5ZEQvbk1jemcL85gT2zkstQGv+x9ABOtOVUt4P5kyXGRncCqlEzz85iF0PoAPqHGgCzHP7p6RBin8DfgHEGvcBRv9R9AAAAABJRU5ErkJggg==')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "PipelineRun",
                "title": "PipelineRun",
                "src": "/ibm-cloudnative-journey/static/9f446c196dfa2c4a625858139fc1d00f/3cbba/pipeline-os.png",
                "srcSet": ["/ibm-cloudnative-journey/static/9f446c196dfa2c4a625858139fc1d00f/7fc1e/pipeline-os.png 288w", "/ibm-cloudnative-journey/static/9f446c196dfa2c4a625858139fc1d00f/a5df1/pipeline-os.png 576w", "/ibm-cloudnative-journey/static/9f446c196dfa2c4a625858139fc1d00f/3cbba/pipeline-os.png 1152w", "/ibm-cloudnative-journey/static/9f446c196dfa2c4a625858139fc1d00f/0b124/pipeline-os.png 1728w", "/ibm-cloudnative-journey/static/9f446c196dfa2c4a625858139fc1d00f/6a339/pipeline-os.png 2048w"],
                "sizes": "(max-width: 1152px) 100vw, 1152px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span></li>
        </ul>
      </Tab>
      <Tab label="Tekton CLI" mdxType="Tab">
        <p>{`If you are running `}<strong parentName="p">{`Tekton`}</strong>{` with IBM Cloud Pak for Applications or Knative
with Kubernetes managed service your dashboard view will look similar to below.`}</p>
        <ul>
          <li parentName="ul">{`Review your `}<strong parentName="li">{`Pipeline`}</strong><pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`tkn pipelinerun list              
`}</code></pre></li>
          <li parentName="ul">{`Review `}<strong parentName="li">{`Pipeline`}</strong>{` details`}<pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`tkn pipelinerun describe {pipeline-name}              
`}</code></pre></li>
        </ul>
      </Tab>
    </Tabs>
    <h3>{`Running Application`}</h3>
    <p>{`Once the `}<strong parentName="p">{`Tekton`}</strong>{` pipeline has successfully completed you can validate your
app has been successfully deployed.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Open the OpenShift Console and select the {new-namespace} project and click on `}<strong parentName="p">{`Workloads`}</strong>{`
`}<span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "45.138888888888886%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAABkElEQVQoz6WQW09TURBGD1TaUkTiA0SU8GyESmktvZCI8uRfMyHx1QjYFlD+jS/E0gRKEwjEhEsvnO7dc13OOanQAOHFSVZm59sz357ZxvT0S17NzDI59YJnE89JjI0TjY0yEo1jDEWE4fsYwwxFRognngpjxOIJYqMJIk+iGNmVT7wrfCCdX+Hz2hdKlR02ShXKWz+obP98mJ1dypK/ftsQNlnfLPG9vEWpvI2RKa6Szr0nW/xIo9Hgf8OYSy3xOpkhuZjj116Vs5ai/qcpWdNUzqO0tEtTO3SEttDqWhjJdJ43C0u8TRf4XTvAdOBSituWh3J8lO3R7ROcQy3U/VDryflUuZwI2nICwwLBlIHx/n4N87rD5cU5Pa2wLUuW8B/gNpTnUzctam0tDwwYzi/mOTish0Vaa1zXxfM8fN+/4V+Etn3NFY67Nkdiajt9w2DlhUyRvWqNK1P+zuzdaw4fkpWa1wpXGhnQb2plACMwm0vlSGWXqcrKqmfRMbvhhI40DmLZNlrubcl37wIC/S9pVz2LiM+H+wAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "OpenShift",
              "title": "OpenShift",
              "src": "/ibm-cloudnative-journey/static/a25b80e0df63b105bb82931ba91f5301/3cbba/openshiftconsole.png",
              "srcSet": ["/ibm-cloudnative-journey/static/a25b80e0df63b105bb82931ba91f5301/7fc1e/openshiftconsole.png 288w", "/ibm-cloudnative-journey/static/a25b80e0df63b105bb82931ba91f5301/a5df1/openshiftconsole.png 576w", "/ibm-cloudnative-journey/static/a25b80e0df63b105bb82931ba91f5301/3cbba/openshiftconsole.png 1152w", "/ibm-cloudnative-journey/static/a25b80e0df63b105bb82931ba91f5301/0b124/openshiftconsole.png 1728w", "/ibm-cloudnative-journey/static/a25b80e0df63b105bb82931ba91f5301/6a339/openshiftconsole.png 2048w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Get the hostname for the application from ingress`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`kubectl get ingress --all-namespace
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li">{`You can use the the `}<inlineCode parentName="p">{`igc`}</inlineCode>{` command to get the name of the deployed application`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`igc ingress -n {new-namespace}
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Use the application URL to open it your browser for testing`}</p>
      </li>
    </ul>
    <p>{`Once you become familiar with deploying code into OpenShift using `}<strong parentName="p">{`Tekton
`}</strong>{`, read up about how you can manage code deployment with `}<inlineCode parentName="p">{`Continuous
 Delivery`}</inlineCode>{` with `}<inlineCode parentName="p">{`ArgoCD`}</inlineCode>{` and `}<inlineCode parentName="p">{`Artifactory`}</inlineCode></p>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink to="../../developer-intermediate/artifact-management" mdxType="AnchorLink">Artifact Management with Artifactory</AnchorLink>
  <AnchorLink to="../../guides/continuous-delivery" mdxType="AnchorLink">Continuous Delivery with ArgoCD</AnchorLink>
    </AnchorLinks>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      